/**
 * ViewManager
 *
 * The main viewmanager
 *
 * @return {view}
 */

OT.createNS('OT.Search.BaseView');

OT.Search.BaseView = (function() {
    'use strict';

    var vm = Backbone.ViewManager = Backbone.ViewManager || {};

    // base FilterGroup view
    vm.BaseView.FilterGroup = vm.BaseView.extend({

        template: 'Common/Filters/_FilterGroup',

        initialize: function() {
            this.beforeInitialize();

            tombstone('FilterGroup-js-initialize');

            OT.Events.on('results:updated', $.proxy(this, 'checkIfRenderNeeded'));
        },

        beforeRender: function() {
            this.templateData   = OT.Search.Data.get().Filters[this.filterName];
            this.additionalData = {
                title: this.title,
                name: this.name,
                param: this.paramName
            };

            tombstone('FilterGroup-js-beforeRender');

            return this;
        },

        checkIfRenderNeeded: function(e, data) {
            tombstone('FilterGroup-js-checkIfRenderNeeded');
            data = data || {};

            if(data.historyBack || data.modal === this.name || this.paramNotSearchedFor()) {
                this.render();
            }

            if(this.state) {
                this.updateStates();
            }
        },

        paramNotSearchedFor: function() {
            return OT.Search.Data.get().Request[this.paramName] === null;
        },


        updateStates: function() {
            if(!(this.paramName instanceof Array)) {
                return false;
            }

            var _this = this;

            _.each(_this.paramName, function(name) {
                _this.state[name] = OT.Search.Data.get().Request[name] === null ? [] : OT.Search.Data.get().Request[name].split(',');
            });
        },

        updateFilterGroupSelectionCount: function () {
            var filterGroup = this.$el.closest('.filter-option');

            if (filterGroup) {
                var count = filterGroup.find('.highlight').length;
                var text = count > 0 ? '(' + count + ')' : '';

                filterGroup.find('.filter-count').text(text);
            }
        },

        setNewSearchFilters: function (e, $elem, additionalData) {
            tombstone('FilterGroup-js-setNewSearchFilters');
            var filterData = OT.Common.Helpers.buildObjectFromCheckedkItems($elem || this.$el);

            OT.Search.Params.set(filterData);
            OT.Search.Params.set({
                'From': null
            });

            OT.Search.Requests.Results.get({
                additionalData: additionalData
            });
        },

        // To be overritten by child views
        beforeInitialize: function() {}

    });

})();